<div class="w-full h-full">
  <iframe
    src="https://chatcenter.ccds.all.tz/widget?website_token=NfTidb5YzrvHVnw4g9xiHdNK&amp;cw_conversation=eyJhbGciOiJIUzI1NiJ9.eyJzb3VyY2VfaWQiOiJmMGU4ZTMxYi0zZGZkLTQ5NmYtOTM4ZC04ZmEyODA0OGZiZjYiLCJpbmJveF9pZCI6MzN9.L7d1kUfvWq1oL0TdKBHvXn_edeJkhz6WGkkIpCsHfcA"
    allow="camera; microphone; fullscreen; display-capture; picture-in-picture; clipboard-write"
    style="width: 100%; height: 100%"
    (load)="isLoading = false"
    title=""
    id="chatwoot_live_chat_widget"
  ></iframe>
</div>
